export enum ServiceListType {
  history = 'Previous Treatments',
  favourites = 'Favourites'
}
